/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

interface Props {
  focused?: boolean;
}

export const SearchResultsItem = styled.div<Props>`
  list-style: none;
  /* border: 1px solid rgba(119, 122, 175, 0.1);
  border-bottom-width: 1px; */
  position: relative;
  background-color: ${(props) => (props.focused ? "#cacaca" : "")};
`;

// TODO: rename this
export const StyledLink = styled.div`
  cursor: pointer;
  list-style: none;
  border: 0 solid #36395a;
  text-decoration: inherit;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 24px;
  overflow: hidden;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 16px;
  color: #000000;
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 75ms;
`;

export const ResultRight = styled.div`
  list-style: none;
  line-height: 24px;
  /* --text-opacity: 1;
	color: rgba(255, 255, 255, var(--text-opacity)); */
  flex: none;
  margin-left: 8px;
  padding: 2px;
  width: 24px;
`;

export const ResultLeft = styled.div`
  list-style: none;
  line-height: 24px;
  /* color: rgb(54, 57, 90); */
  display: flex;
  align-items: flex-start;
  overflow: hidden;
`;

export const ResultIconLeft = styled.div`
  list-style: none;
  line-height: 24px;
  display: flex;
  justify-content: center;
  flex: none;
  height: 24px;
  margin-top: 4px;
  padding-bottom: 4px;
  color: rgb(182, 183, 213);
  width: 32px;
  margin-right: 16px;
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 75ms;
`;

export const ResultContentWrapper = styled.div`
  list-style: none;
  line-height: 24px;
  /* color: rgb(255, 255, 255); */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  :hover {
    text-decoration: underline;
  }
`;
